import {
  LIST_BRANCH_PRICE_CATEGORY_REQUEST,
  LIST_BRANCH_PRICE_CATEGORY_SUCCESS,
  LIST_BRANCH_PRICE_CATEGORY_FAIL,
  CREATE_BRANCH_PRICE_CATEGORY_REQUEST,
  CREATE_BRANCH_PRICE_CATEGORY_SUCCESS,
  CREATE_BRANCH_PRICE_CATEGORY_FAIL,
  DETAIL_BRANCH_PRICE_CATEGORY_REQUEST,
  DETAIL_BRANCH_PRICE_CATEGORY_SUCCESS,
  DETAIL_BRANCH_PRICE_CATEGORY_FAIL,
  UPDATE_BRANCH_PRICE_CATEGORY_REQUEST,
  UPDATE_BRANCH_PRICE_CATEGORY_SUCCESS,
  UPDATE_BRANCH_PRICE_CATEGORY_FAIL,
  DELETE_BRANCH_PRICE_CATEGORY_REQUEST,
  DELETE_BRANCH_PRICE_CATEGORY_SUCCESS,
  DELETE_BRANCH_PRICE_CATEGORY_FAIL,
  RESET_BRANCH_PRICE_CATEGORY,
  LIST_BRANCH_PRICE_CATEGORY_SUMMARY_REQUEST,
  LIST_BRANCH_PRICE_CATEGORY_SUMMARY_SUCCESS,
  LIST_BRANCH_PRICE_CATEGORY_SUMMARY_FAIL
} from '../../constants/branch-price-category'

const initialState = {
  loading: false,
  loadingCreate: false,
  loadingUpdate: false,
  loadingDelete: false,
  loadingDetail: false,
  loadingSummary: false,
  priceCategoriesSummary: [],
  priceCategories: [],
  priceCategory: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const listBranchPriceCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_BRANCH_PRICE_CATEGORY_REQUEST:
      return { ...state, loading: true }
    case LIST_BRANCH_PRICE_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        priceCategories: action.payload,
        pageable: action.pageable
      }
    case LIST_BRANCH_PRICE_CATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case LIST_BRANCH_PRICE_CATEGORY_SUMMARY_REQUEST:
      return { ...state, loadingSummary: true, error: '' }
    case LIST_BRANCH_PRICE_CATEGORY_SUMMARY_SUCCESS:
      return {
        ...state,
        priceCategoriesSummary: action?.payload,
        loadingSummary: false
      }
    case LIST_BRANCH_PRICE_CATEGORY_SUMMARY_FAIL:
      return {
        ...state,
        loadingSummary: true,
        error: action.payload
      }
    case CREATE_BRANCH_PRICE_CATEGORY_REQUEST:
      return { ...state, loadingCreate: true, error: '' }
    case CREATE_BRANCH_PRICE_CATEGORY_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_BRANCH_PRICE_CATEGORY_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_BRANCH_PRICE_CATEGORY_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_BRANCH_PRICE_CATEGORY_SUCCESS:
      return { ...state, loadingDetail: false, textTemplate: action.payload }
    case DETAIL_BRANCH_PRICE_CATEGORY_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload
      }
    case UPDATE_BRANCH_PRICE_CATEGORY_REQUEST:
      return { ...state, loadingUpdate: true, error: '' }
    case UPDATE_BRANCH_PRICE_CATEGORY_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_BRANCH_PRICE_CATEGORY_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_BRANCH_PRICE_CATEGORY_REQUEST:
      return { ...state, loadingDelete: true, error: '' }
    case DELETE_BRANCH_PRICE_CATEGORY_SUCCESS:
      return { ...state, loadingDelete: false, error: '' }
    case DELETE_BRANCH_PRICE_CATEGORY_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case RESET_BRANCH_PRICE_CATEGORY:
      return { ...state, loading: false, error: null }
    default:
      return state
  }
}

export default listBranchPriceCategoryReducer
